<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/configuration")
            i.fa.fa-cogs
            span.ml-1 {{ $t("ui.configuration") }}
        b-breadcrumb-item
          router-link(to="/configuration/ibclogin")
            i.fa.fa-sign-in-alt
            span.ml-1 {{ $t("ui.ibc_login") }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-6.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="loginSearch" :placeholder="$t('message.search_by_id_providerid_url')")
                  div.col-sm-3.col-md-2.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="url") {{ $t("ui.url") }}
                      b-form-radio(value="username") {{ $t("ui.username") }}
                      b-form-radio(value="fullName") {{ $t("ui.fullname") }}
                  div.col-md-2.mb-1
                    SubmitButton.float-right(
                      :loading="loading"
                      icon="fa fa-trash"
                      :text="$t('ui.delete_disabled_login')"
                      type="button"
                      @click="deleteDisabledLogin()"
                      variant="danger"
                      size="sm"
                      ).mr-2
              div.col-md-12
                b-button(v-b-modal.addLogin type="button" variant="primary" size="sm" :disabled="loading").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_login") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $tc('ui.providers', 1) }}
                    th.sticky-position
                      span {{ $t('ui.url') }}
                    th.sticky-position(@click="sortOrder('login_id')")
                      span {{ $t('ui.username') }}
                      i(:class="changeSortKey('login_id')")
                    th.sticky-position(@click="sortOrder('password')")
                      span {{ $t('ui.password') }}
                      i(:class="changeSortKey('password')")
                    th.text-center.sticky-position(width=100)
                      span {{ $t("ui.action") }}
                    th.text-center.sticky-position(width=100 style="z-index: 10;" @click="sortOrder('login_disabled')")
                      span {{ $t("ui.disabled") }}
                      i(:class="changeSortKey('login_disabled')")
                    th.sticky-position(@click="sortOrder('login_name')")
                      span {{ $t("ui.fullname") }}
                      i(:class="changeSortKey('login_name')")
                    th.sticky-position
                      span {{ $t("ui.status") }}
                    th.text-center.sticky-position(@click="sortOrder('assigned')")
                      span {{ $t("ui.assigned") }}
                      i(:class="changeSortKey('assigned')")
                    th.sticky-position(@click="sortOrder('bot_id')")
                      span {{ $tc('ui.bots', 1) }}
                      i(:class="changeSortKey('bot_id')")
                    th.text-right.sticky-position(width=200 @click="sortOrder('created_on')")
                      span {{ $t("ui.created_on") }}
                      i(:class="changeSortKey('created_on')")
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredLoginList")
                    td
                      span {{ item.provider_id }}
                    td
                      b-link(:href="item.host_url") {{ item.host_url }}
                    td
                      span {{ item.login_id }}
                    td
                      span {{ item.password }}
                    td.actions
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-lock.text-warning(href="#" @click="onPassword(item)" :title="$t('ui.password')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    td.actions
                      div.d-flex.justify-content-center.align-items-center
                        label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                          input.switch-input(type="checkbox" v-model="item.login_disabled" @change="changedDisable(item, $event)")
                          span.switch-slider(:data-checked='on' :data-unchecked='off')
                    td
                      span {{ item.login_name }}
                    td
                      span {{ item.status }}
                    td.text-center
                      span
                        i(:class="{'fas fa-check text-info': item.assigned, 'fas fa-times text-warning': !item.assigned  }")
                    td
                      span {{ item.bot_id }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addlogin(:providerID="providerID" @clicked="addLogin" @failed="handleFailed")
      editlogin(ref="editlogin" :providerID="editSelectedProviderID" :hostID="editSelectedHostID" :username="editSelectedUsername" :fullName="editSelectedFullName"
                @clicked="editLogin" @failed="handleFailed")
      deletelogin(ref="deletelogin" :providerID="deleteSelectedProviderID" :username="deleteSelectedUsername"
                  @clicked="deleteLogin" @failed="handleFailed")
      changepwduser(ref="changepwduser" :providerID="editSelectedProviderID" :username="editSelectedUsername" :password="editSelectedPassword"
                    @clicked="updatePwdUser" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addlogin from "@/components/login/addLogin.vue";
import editlogin from "@/components/login/editLogin.vue";
import deletelogin from "@/components/login/deleteLogin.vue";
import changepwduser from "@/components/login/changePwdUser.vue";
import DebounceInput from "@/library/DebounceInput";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    addlogin,
    editlogin,
    deletelogin,
    changepwduser,
    DebounceInput,
    SubmitButton
  },
  data() {
    return {
      loading: false,
      filterBy: "username",
      loginList: [],
      loginSearch: "",
      providerList: [],
      providerID: "IBC",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedProviderID: "",
      editSelectedHostID: "",
      editSelectedUsername: "",
      editSelectedPassword: "",
      editSelectedFullName: "",
      deleteSelectedProviderID: "",
      deleteSelectedHostID: "",
      deleteSelectedUsername: "",
      deleteSelectedPassword: "",
      deleteSelectedFullName: "",
      sortKey: "login_id",
      sortType: "asc",
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredLoginList() {
      return this.loginList.filter(item => {
        if (this.filterBy == "url") {
          return item.host_url.toLowerCase().indexOf(this.loginSearch.toLowerCase()) > -1;
        } else if (this.filterBy == "username") {
          return item.login_id.toLowerCase().indexOf(this.loginSearch.toLowerCase()) > -1;
        } else {
          return item.login_name.toLowerCase().indexOf(this.loginSearch.toLowerCase()) > -1;
        }
      })
      .sort((a, b) => {
        if (this.sortType == 'asc') {
          if (this.sortKey == 'assigned' || this.sortKey == 'login_disabled') {
            return a[this.sortKey] === b[this.sortKey] ? 0 : a[this.sortKey] ? -1 : 1;
          }
          else if (this.sortKey == 'bot_id') {
            if (a[this.sortKey] === b[this.sortKey]) return 0;
            if (a[this.sortKey] === null) return 1;
            if (b[this.sortKey] === null) return -1;

            return a[this.sortKey] > b[this.sortKey] ? 1 : -1;
          }
          else {
            return a[this.sortKey] > b[this.sortKey] ? 1 : -1;
          }
        }
        else {
          if (this.sortKey == 'assigned' || this.sortKey == 'login_disabled') {
            return a[this.sortKey] === b[this.sortKey] ? 0 : a[this.sortKey] ? 1 : -1;
          }
          else if (this.sortKey == 'bot_id') {
            if (a[this.sortKey] === b[this.sortKey]) return 0;
            if (a[this.sortKey] === null) return -1;
            if (b[this.sortKey] === null) return 1;

            return a[this.sortKey] < b[this.sortKey] ? 1 : -1;
          }
          else {
            return a[this.sortKey] < b[this.sortKey] ? 1 : -1;
          }
        }
      });
    }
  },
  mounted() {
    this.getLoginList();
  },
  methods: {
    sortOrder(key) {
      console.log(key);
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getLoginList() {
      let url = config.loginListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.login,
        provider_id: this.providerID
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.loginList = response.data.tbl_login_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedDisable: function(disabled, eventStatus) {
      let getUsername = disabled.provider_id + " - " + disabled.login_id;

      this.$helpers
        .alert({
          title: this.$t("ui.disabled"),
          text: this.$t("message.change_disable_confirm", { name: getUsername }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.submit(disabled, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !disabled.login_disabled;
          }
        });
    },
    submit: function(disabled, status) {
      let url = config.editLoginDisabledUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.login,
        target_provider_id: disabled.provider_id,
        target_login_id: disabled.login_id,
        login_disabled: status
      };

      this.feedback.success = true;
      //this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          //this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                disabled.login_disabled = status;
                this.$helpers.showDialog(this.$t("ui.disabled"), this.$t("message.success"), "success");
              } else {
                disabled.login_disabled = !status;
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onEdit(e) {
      this.editSelectedProviderID = e.provider_id;
      this.editSelectedHostID = e.host_id;
      this.editSelectedUsername = e.login_id;
      this.editSelectedFullName = e.login_name;
      this.$refs.editlogin.$refs.editLogin.show();
    },
    onPassword(e) {
      (this.editSelectedProviderID = e.provider_id), (this.editSelectedUsername = e.login_id), (this.editSelectedPassword = e.password), this.$refs.changepwduser.$refs.changePwdUser.show();
    },
    onDelete(e) {
      this.deleteSelectedProviderID = e.provider_id;
      this.deleteSelectedUsername = e.login_id;
      this.$refs.deletelogin.$refs.deleteLogin.show();
    },
    addLogin: function(providerID, hostID, hostURL, username, password, fullName) {
      let newLogin = {
        provider_id: providerID.toUpperCase(),
        host_id: hostID,
        host_url: hostURL,
        login_id: username.toLowerCase(),
        password: password,
        login_name: fullName,
        status: 'ACTIVE',
        created_on: new Date()
      };
      this.loginSearch = "";
      this.loginList.unshift(newLogin);
      this.$helpers.showDialog(this.$t("ui.combine.add_login"), this.$t("message.success"), "success");
    },
    editLogin: function(providerID, hostID, hostURL, username, fullName) {
      this.loginList.filter(function(loginInfo) {
        if (loginInfo.login_id == username) {
          loginInfo.provider_id = providerID.toUpperCase();
          (loginInfo.host_id = hostID), (loginInfo.host_url = hostURL), (loginInfo.login_name = fullName);
        }
      });
      this.$helpers.showDialog(this.$t("ui.combine.edit_login"), this.$t("message.success"), "success");
    },
    deleteLogin: function(providerID, username) {
      let i = this.loginList.map(loginInfo => loginInfo.provider_id + loginInfo.login_id).indexOf(providerID + username);
      this.loginList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_login"), this.$t("message.success"), "success");
    },
    updatePwdUser: function(providerID, username, password) {
      this.loginList.filter(function(loginInfo) {
        if (loginInfo.login_id == username) {
          loginInfo.password = password;
        }
      });
      this.$helpers.showDialog(this.$t("ui.password"), this.$t("message.success"), "success");
    },
    deleteDisabledLogin: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.delete_disabled_login"),
          text: this.$t("message.delete_disabled_login_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDeleteDisabledLogin();
          }
        });
    },
    confirmDeleteDisabledLogin() {
      let url = config.deleteLoginDisabledUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.login,
        target_provider_id: this.providerID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // this.$snotify.success(this.$t("message.success"));
                this.$helpers.showDialog(this.$t("ui.delete_disabled_login"), this.$t("message.success"), "success");
                this.getLoginList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>
